import React from 'react';
import { Heading5 } from '../typography/Heading.styles';
import { RightsLink, StyledMissingContent } from './MissingContent.styles';
import PlayText from '../typography/PlayText/PlayText';

type Props = {
    heading?: string;
};

export const MissingContent = ({ heading = 'Inga avsnitt tillgängliga just nu.' }: Props): JSX.Element => (
    <StyledMissingContent>
        <Heading5>{heading}</Heading5>
        <RightsLink href="https://kontakt.svt.se/guide/rattigheter">
            <PlayText as="span">Hur funkar upphovsrätt i SVT Play?</PlayText>
        </RightsLink>
    </StyledMissingContent>
);

export default MissingContent;
